import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { delay, map } from 'rxjs/operators';

export type Theme =
  | 'platform-green'
  | 'admin-blue'
  | 'reveal-blue'
  | 'vizient-orange';
export type GlobalStyle = 'platform' | 'admin' | 'vizient';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private _themeLoading$ = new BehaviorSubject(true);
  private _globalStylesLoading$ = new BehaviorSubject(true);
  themeLoading$ = combineLatest([
    this._themeLoading$,
    this._globalStylesLoading$,
  ]).pipe(
    map(
      ([themeLoading, globalStylesLoading]) =>
        themeLoading && globalStylesLoading,
    ),
    delay(150),
  );

  constructor(@Inject(DOCUMENT) private document: Document) {}

  setTheme(theme: Theme) {
    this.setDomElement(theme + '-theme', this._themeLoading$, 'theme');
  }

  setGlobalStyles(globalStylesName: GlobalStyle) {
    this.setDomElement(
      globalStylesName + '-global-styles',
      this._globalStylesLoading$,
      'global-styles',
    );
  }

  private setDomElement(
    fileName: string,
    loadingSubject$: Subject<boolean>,
    elementId: string,
  ) {
    loadingSubject$.next(true);

    const head = this.document.getElementsByTagName('head')[0];
    let element = this.document.getElementById(elementId) as HTMLLinkElement;
    const hrefPath = '/aptitude/static/platform/' + fileName + '.css';

    if (element) {
      if (!element.href.includes(hrefPath)) {
        element.href = hrefPath;
      }
      loadingSubject$.next(false);
      return;
    }

    element = this.document.createElement('link');
    element.id = 'app-theme';
    element.rel = 'stylesheet';
    element.href = hrefPath;

    element.addEventListener('load', () => {
      loadingSubject$.next(false);
    });
    head.appendChild(element);
  }
}
